module.exports = "/_next/static/images/yuvalcorey-4fecc6c1a19aa0ea89603db0caefc345.jpg";